import { axiosInstance } from '@configs/axios/axiosInstance';

import type { UserNotificationPreferences } from '../types/userNotificationPreferences.types';

export async function getUserNotificationPreferences(): Promise<UserNotificationPreferences[]> {
  const { data } = await axiosInstance.get<UserNotificationPreferences[]>(
    '/client-profiles/notification-preferences'
  );
  return data;
}
